import { TR, TD } from '../InsightTemplate/InsightTemplateElements';

const FONT_SIZE = 16;
const TABLE_HEADER_COLOR = 'rgba(0, 0, 0, 0.45)';
const TABLE_CELL_STYLE = {
    padding: '8px 12px',
    fontSize: FONT_SIZE * 0.75,
    border: '1px solid #e0e0e0',
    textAlign: 'left' as const,
};

type Props = {
    description: string;
    outcome: string;
    call_date: string;
    realization_date: string;
    confidence: string;
    window: string;
    consensus: string;
};

const PredictionTemplatePdfBody = ({
    description,
    outcome,
    call_date,
    realization_date,
    confidence,
    window,
    consensus,
}: Props) => {
    return (
        <>
            <TR>
                <TD style={{ padding: '0 0 20px 0' }}>
                    <div
                        style={{
                            fontFamily: 'OpenSans',
                            fontSize: FONT_SIZE,
                            lineHeight: 1.6,
                            color: '#000',
                            width: '100%',
                        }}>
                        {description}
                    </div>
                </TD>
            </TR>
            <TR>
                <TD style={{ padding: 0 }}>
                    <table
                        style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            fontFamily: 'OpenSans',
                        }}>
                        <thead>
                            <tr style={{ backgroundColor: '#f5f5f5' }}>
                                <th style={{ ...TABLE_CELL_STYLE, color: TABLE_HEADER_COLOR, fontWeight: 600 }}>
                                    Outcome
                                </th>
                                <th style={{ ...TABLE_CELL_STYLE, color: TABLE_HEADER_COLOR, fontWeight: 600 }}>
                                    Call Made
                                </th>
                                <th style={{ ...TABLE_CELL_STYLE, color: TABLE_HEADER_COLOR, fontWeight: 600 }}>
                                    Realization Date
                                </th>
                                <th style={{ ...TABLE_CELL_STYLE, color: TABLE_HEADER_COLOR, fontWeight: 600 }}>
                                    Confidence
                                </th>
                                <th style={{ ...TABLE_CELL_STYLE, color: TABLE_HEADER_COLOR, fontWeight: 600 }}>
                                    Window
                                </th>
                                <th style={{ ...TABLE_CELL_STYLE, color: TABLE_HEADER_COLOR, fontWeight: 600 }}>
                                    Consensus
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style={{ backgroundColor: 'white' }}>
                                <td style={TABLE_CELL_STYLE}>{outcome}</td>
                                <td style={TABLE_CELL_STYLE}>{call_date}</td>
                                <td style={TABLE_CELL_STYLE}>{realization_date}</td>
                                <td style={TABLE_CELL_STYLE}>{confidence}</td>
                                <td style={TABLE_CELL_STYLE}>{window}</td>
                                <td style={TABLE_CELL_STYLE}>{consensus}</td>
                            </tr>
                        </tbody>
                    </table>
                </TD>
            </TR>
        </>
    );
};

export default PredictionTemplatePdfBody;
